import { AkaFamilyAccidentProductIntroFormValues } from "./akaFamilyAccidentProductIntroInterfaces";

export const AKA_FAMILY_ACCIDENT_PRODUCT_INTRO_INITIAL_FORM_VALUES: Partial<AkaFamilyAccidentProductIntroFormValues> =
  {
    hasDeathCoverage: false,
    hasDisabilityCoverage: false,
    hasProfessionalDisabilityCoverage: false,
  };
